import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  padding: 55px 30px 30px;

  @media ${minBp('tablet')} {
    padding: 75px 60px 60px;
    width: 600px;
  }

  @media ${minBp('tabletLarge')} {
    width: 800px;
  }
`;

export const MainText = styled.p`
  color: #585a5f;
  font-size: 12px;
  line-height: 19px;
  margin: 0;

  @media ${minBp('desktop')} {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const DisclaimerWrapper = styled.div`
  color: #585a5f;
  font-size: 12px;
  line-height: 19px;
  margin: 0;

  p {
    margin-bottom: 20px;
  }

  @media ${minBp('desktop')} {
    font-size: 14px;
    line-height: 22px;
  }
`;
